import axios from 'axios';

export const HAS_DRAFTSINDIVIDUAL_BEGIN = 'HAS_DRAFTSINDIVIDUAL_BEGIN';
export const HAS_DRAFTSINDIVIDUAL_SUCCESS = 'HAS_DRAFTSINDIVIDUAL_SUCCESS';
export const HAS_DRAFTSINDIVIDUAL_FAILURE = 'HAS_DRAFTSINDIVIDUAL_FAILURE';

export const hasDraftsIndividualBegin = () => ({
    type: HAS_DRAFTSINDIVIDUAL_BEGIN
});

export const hasDraftsIndividualSuccess = (value) => ({
    type: HAS_DRAFTSINDIVIDUAL_SUCCESS,
    payload: value
});

export const hasDraftsIndividualFailure = (error) => ({
    type: HAS_DRAFTSINDIVIDUAL_FAILURE,
    payload: error
});

export const hasDraftsIndividual = (webappurlForms, accessToken) => {
    return dispatch => {
        const data = {
            "organisationId": ""
        };

        const options = {
            headers: {
                'Authorization': "Bearer " + accessToken,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        dispatch(hasDraftsIndividualBegin());
       
        return axios.post(webappurlForms + "/api/myCASA/Forms/HasDraftsIndividual/v1", data, options)
            .then(response => {
                if (response.data.wasSuccessful) {
                    return dispatch(hasDraftsIndividualSuccess(response.data.drafts))
                }
                else {
                    return dispatch(hasDraftsIndividualFailure("System error HDI.1: " + response.data.error));
                }
            })
            .catch(error => {
                return dispatch(hasDraftsIndividualFailure(error.response ? error.response.data.errors : error));
            });
    }
}
